import { render } from "./ClosedTickets.vue?vue&type=template&id=8b34f47e&ts=true"
import script from "./ClosedTickets.vue?vue&type=script&lang=ts"
export * from "./ClosedTickets.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__